/**
 * 分享配置 - 统一的分享配置管理
 * 避免在多个文件中重复定义相同的配置
 */

/**
 * 根据当前页面路径获取页面特定的默认分享配置
 * @returns {Object} 页面特定的默认分享配置
 */
export function getPageSpecificDefaultConfig() {
  const pathname = window.location.pathname
  
  // 根据页面路径设置不同的默认分享内容
  if (pathname === '/category') {
    return {
      title: '蒙古丽人 - 企业介绍',
      desc: '内蒙古丽人文化传媒有限公司，定制热线：133 4714 1793，专注于蒙古服饰设计、制作、加工和销售，传承和发扬蒙古民族文化。',
      link: '',
      imgUrl: 'https://mall.sainbainu.com/static/images/sharelogo.png',
      appName: '蒙古丽人商城'
    }
  } else if (pathname.startsWith('/product/')) {
    return {
      title: '蒙古丽人商城 - 精选商品',
      desc: '专注于蒙古服饰设计、开发、推广。定制热线：133 4714 1793',
      link: '',
      imgUrl: 'https://mall.sainbainu.com/static/images/sharelogo.png',
      appName: '蒙古丽人商城'
    }
  } else if (pathname === '/products') {
    return {
      title: '蒙古丽人商城 - 商品详情',
      desc: '专注于蒙古服饰设计、开发、推广。定制热线：133 4714 1793',
      link: '',
      imgUrl: 'https://mall.sainbainu.com/static/images/sharelogo.png',
      appName: '蒙古丽人商城'
    }
  } else {
    // 默认首页配置
    return {
      title: '蒙古丽人商城',
      desc: '专注于蒙古服饰设计、开发、推广。定制热线：133 4714 1793',
      link: '',
      imgUrl: 'https://mall.sainbainu.com/static/images/sharelogo.png',
      appName: '蒙古丽人商城'
    }
  }
}

/**
 * 默认分享配置
 */
export const DEFAULT_SHARE_CONFIG = {
  title: '蒙古丽人商城',
  desc: '定制热线：133 4714 1793',
  link: '',
  imgUrl: 'https://mall.sainbainu.com/static/images/sharelogo.png',
  appName: '蒙古丽人商城'
}